import {
    Component,
    ComponentInterface,
    Element,
    h,
    Host,
    Prop,
    State,
} from "@stencil/core";
import {
    FilterDataProvider,
    FilterDataProviderState,
    getFilterDataProvider,
} from "../../apis/stateful-content";
import { getActiveFilterCount } from "../stateful-filter/stateful-filter-utils";

@Component({
    tag: "ux-iws-stateful-filter-button",
    styleUrl: "stateful-filter-button.scss",
})
export class StatefulFilterButton implements ComponentInterface {
    private baseClass = "ux-iws-stateful-filter-button";
    private filterProvider: FilterDataProvider;

    @Element() domNode: HTMLUxIwsStatefulFilterButtonElement;

    /** print debug info */
    @Prop() debug: boolean = false;
    /** scope used to retrieve the filter data provider */
    @Prop() scope: string = "";

    @State() activeFilterCount: number = 0;

    private _log = (...args: any[]) => {
        if (this.debug && console && typeof console.log === "function") {
            console.log(`[Stateful-Filter-Button]:`, ...args);
        }
    };

    componentWillLoad() {
        this.filterProvider = getFilterDataProvider(this.scope);
        this.filterProvider.subscribe(this.handleFilterProviderState);
        this.filterProvider.getData();
    }

    private handleFilterProviderState = ({
        filterQuery,
    }: FilterDataProviderState) => {
        this._log(`handleFilterProviderState filterQuery: "${filterQuery}"`);
        this.activeFilterCount = getActiveFilterCount(filterQuery);
    };

    render() {
        return (
            <Host class={this.baseClass}>
                <button>
                    {this.activeFilterCount > 0 && (
                        <ux-badge>{this.activeFilterCount}</ux-badge>
                    )}
                    <ux-icon
                        name="filter-horizontal-triple"
                        size-s="20"
                    ></ux-icon>
                    <span class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase">
                        <slot />
                    </span>
                </button>
            </Host>
        );
    }
}
